import React from 'react'
import localize from '../localize';
import './TimeSelector.css';

import RadioLabelGroup from '../RadioLabelGroup'

export default localize()(({ i18n, timeWindow, setWindow }) => {
  const options = [
    {label: i18n.t('pages.scores.changeTime.last_30'), value: 2592000},
    {label: i18n.t('pages.scores.changeTime.last_7'), value: 604800},
    {label: i18n.t('pages.scores.changeTime.last_day'), value: 172800}
  ]

  return (
    <div className="centered-content time-selector">
      <div className="button-group">
        <RadioLabelGroup value={timeWindow} options={options} onChange={setWindow} />
      </div>
      <div className="grey-bar"/>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/TimeSelector/index.js